import axios from "../util/axios";
import Token from "../util/Token";

const COMPANY_URL = "/cms/v2/company";

// Read the Failed Transactions flag for the CALLER's own company (JWT-keyed,
// authenticated-only, resilient — defaults to off so nothing ever blocks render).
async function getFailedTxnConfig() {
  try {
    Token.setAuthToken();
    const { status, data } = await axios.get("/cms/v1/failed-txn-config");
    if (status === 200 && data.success) {
      return { failedTxnEnabled: data.data?.failedTxnEnabled === true };
    }
    return { failedTxnEnabled: false };
  } catch (error) {
    return { failedTxnEnabled: false };
  }
}

// Read a SPECIFIC company's flag (super-admin Company → Settings tab).
async function getCompanyFailedTxnConfig(companyId) {
  try {
    Token.setAuthToken();
    const { status, data } = await axios.get(
      `${COMPANY_URL}/${companyId}/failed-txn-config`
    );
    if (status === 200 && data.success) {
      return { failedTxnEnabled: data.data?.failedTxnEnabled === true };
    }
    return { failedTxnEnabled: false };
  } catch (error) {
    return { failedTxnEnabled: false };
  }
}

async function updateCompanyFailedTxnConfig(companyId, failedTxnEnabled) {
  Token.setAuthToken();
  const { data } = await axios.put(
    `${COMPANY_URL}/${companyId}/failed-txn-config`,
    { failedTxnEnabled: failedTxnEnabled === true }
  );
  return { failedTxnEnabled: data?.data?.failedTxnEnabled === true };
}

const failedTxnService = {
  getFailedTxnConfig,
  getCompanyFailedTxnConfig,
  updateCompanyFailedTxnConfig,
};

export default failedTxnService;
